import { render } from "./AddEtudiant.vue?vue&type=template&id=556bc8a2&scoped=true&ts=true"
import script from "./AddEtudiant.vue?vue&type=script&lang=ts"
export * from "./AddEtudiant.vue?vue&type=script&lang=ts"

import "./AddEtudiant.vue?vue&type=style&index=0&id=556bc8a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556bc8a2"]])

export default __exports__